<template>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_3054_27951)">
            <path d="M12.6663 6H9.99967V2H5.99967V6H3.33301L7.99967 10.6667L12.6663 6ZM3.33301 12V13.3333H12.6663V12H3.33301Z" :fill="color"/>
        </g>
        <defs>
            <clipPath id="clip0_3054_27951">
                <rect width="16" height="16" fill="white"/>
            </clipPath>
        </defs>
    </svg>
</template>

<script setup>
import { toRefs } from 'vue';

const props = defineProps({
    color: {
        type: String,
        default: "#182333"
    }
})

const { color } = toRefs(props)
</script>